'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Button = require('react-bootstrap/lib/Button');

var _Button2 = _interopRequireDefault(_Button);

var _reactTooltip = require('react-tooltip');

var _reactTooltip2 = _interopRequireDefault(_reactTooltip);

var _common = require('../common');

var _containers = require('../../containers');

var _constants = require('../../constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var PERMISSIONS = _constants.AppConstants.PERMISSIONS;
var DeleteReturnButton = (_temp = _class = function (_Component) {
  _inherits(DeleteReturnButton, _Component);

  function DeleteReturnButton() {
    _classCallCheck(this, DeleteReturnButton);

    return _possibleConstructorReturn(this, (DeleteReturnButton.__proto__ || Object.getPrototypeOf(DeleteReturnButton)).apply(this, arguments));
  }

  _createClass(DeleteReturnButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          hasCoopPayment = _props.hasCoopPayment,
          lienReturnId = _props.lienReturnId,
          classNames = (0, _classnames2.default)('btn-delete-return', 'no-padding', className),
          tooltipId = 'delete-lien-return-' + lienReturnId,
          tooltipProps = hasCoopPayment ? { 'data-for': tooltipId, 'data-tip': true } : {};


      return _react2.default.createElement(
        'div',
        { className: 'btn-delete-return-container' },
        _react2.default.createElement(
          'div',
          tooltipProps,
          _react2.default.createElement(
            _reactTooltip2.default,
            { id: tooltipId, type: 'info', effect: 'solid', place: 'right' },
            _react2.default.createElement(
              'div',
              null,
              'Lien returns associated with a CoOp investment are locked from deletion. Please contact CoOp Capital.'
            )
          ),
          _react2.default.createElement(
            _Button2.default,
            _extends({
              bsStyle: 'link',
              className: classNames,
              disabled: hasCoopPayment
            }, this.props),
            _react2.default.createElement(_common.Icon, { type: 'trash' }),
            ' Delete return'
          )
        )
      );
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return DeleteReturnButton;
}(_react.Component), _class.propTypes = {
  className: _propTypes2.default.any,
  hasCoopPayment: _propTypes2.default.bool,
  lienReturnId: _propTypes2.default.string,
  onClick: _propTypes2.default.func
}, _temp);


var GuardedDeleteReturnButton = (0, _containers.createGuardedContainer)({
  disabledComponent: (0, _containers.createDisabledContainer)(DeleteReturnButton),
  enabledComponent: DeleteReturnButton,
  permissionName: PERMISSIONS.DELETE_LIEN_RETURN
});

var _default = GuardedDeleteReturnButton;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(PERMISSIONS, 'PERMISSIONS', '/app/src/components/page-case/DeleteReturnButton.js');
  reactHotLoader.register(DeleteReturnButton, 'DeleteReturnButton', '/app/src/components/page-case/DeleteReturnButton.js');
  reactHotLoader.register(GuardedDeleteReturnButton, 'GuardedDeleteReturnButton', '/app/src/components/page-case/DeleteReturnButton.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/DeleteReturnButton.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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